<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-8" v-if="!cambiada">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.reset_titulo') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <form class="w-100" @submit.prevent="reestablecer">
                            <div class="form-group">
                                <label for="email">{{ $t('formularios.email') }}</label>
                                <input type="email" name="email" id="email" v-model="formData.email"/>
                            </div>
                            <div class="form-group">
                                <label for="password">{{ $t('login.reset_nueva_password') }}</label>
                                <input type="password" name="password" id="password" v-model="formData.password"/>
                            </div>
                            <div class="form-group">
                                <label for="password_confirmation">{{ $t('login.reset_confirmar_password') }}</label>
                                <input type="password" name="password_confirmation" id="password_confirmation" v-model="formData.password_confirmation"/>
                            </div>

                            <div class="form-group" v-if="errors">
                                <div class="alert alert-danger" role="alert">
                                    <ul>
                                        <template v-for="(error, index) in errors.errors">
                                            <li :key="index">
                                                {{ error[0] }}
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>

                            <div class="form-group">
                                <FormCaptchaComponent
                                    ref="captcha"
                                    :siteKey="sitekey"
                                    @success="onCaptchaVerified"
                                    @expired="onCaptchaInvalidHandler"
                                    @error="onCaptchaInvalidHandler"
                                />
                            </div>

                            <div class="row justify-content-md-between">
                                <div class="col-12 col-lg-6">
                                    <button v-if="!loading" type="submit" class="button" name="button" :disabled="!canSubmit">{{ $t('login.enviar') }}</button>
                                    <Skeleton v-else padding="tw:p-0" variant="">
                                        <template #skeleton>
                                            <SkeletonItem customClass="tw:w-full" height="tw:h-10" />
                                        </template>
                                    </Skeleton>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8 col-xl-8" v-if="cambiada">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h3 mb-4 text-center text-uppercase">{{ $t('login.reset_actualizada') }}</div>
                        <div class="mb-4 text-center">
                            <p>
                                {{ $t('login.reset_iniciada_sesion') }}
                            </p>
                        </div>
                        <div class="mb-4 text-center">
                            <router-link
                                class="button"
                                :to="{ name: 'perfil' }"
                            >
                                {{ $t('login.reset_ir_historial') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useResetPassword } from '@/composables/auth/useResetPassword';
    import { Skeleton, SkeletonItem } from '@/modules/front/ui/skeleton';
    import LoginContent from '@/components/frontend/components/LoginContent';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';

    useHead('Reestablecer contraseña');

    const instance = getCurrentInstance();
    const captcha = ref(null);

    const {
        formData,
        errors,
        loading,
        cambiada,
        sitekey,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        submit
    } = useResetPassword();

    /**
     * The layout background is the view's concern, not the reset composable's:
     * a composable named for auth must not carry visual state.
     */
    const footer = computed(() => instance.proxy.$store.getters.getFooter);

    /**
     * The view owns the widget ref, so it also owns resetting it. Expiry and
     * hard errors must clear the token AND hand the user a fresh challenge,
     * preserving the visible feedback (keepFeedback).
     */
    const onCaptchaInvalidHandler = () => {
        onCaptchaInvalid();
        captcha.value?.reset({ keepFeedback: true });
    };

    /**
     * The view owns the widget ref, so it also owns resetting it after a
     * rejected submit. Turnstile tokens are single-use: without this the user
     * is left with a burned token and cannot retry.
     */
    const reestablecer = async() => {
        const { ok } = await submit();

        if (!ok) {
            captcha.value?.reset();
        }
    };
</script>
